import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  thumbnail: {
    base: {
      border: theme.settings.borders.regular,
      borderRadius: theme.settings.borderRadiuses.regular,
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
    },

    clickable: {
      cursor: 'pointer',
    },
    sizes: {
      small: {
        width: '20px',
        height: '20px',
      },
      medium: {
        width: '30px',
        height: '30px',
      },
      large: {
        width: '60px',
        height: '60px',
      },
    },
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  state: {
    backgroundColor: theme.colors.backgrounds.content,
  },
})
